<template>
  <div class="sign-record integral-details" ref="container">

    <div class="header">
      <div class="currentScore">当前购物券</div>
      <div>{{ info.point_money }}</div>
      <div class="line"></div>
      <div class="nav acea-row">
        <div class="item">
          <div class="num">{{ info.sum_sgin_number }}</div>
          <div>累计签到购物券</div>
        </div>
        <div class="item">
          <div class="num">{{ info.sum_sgin_day }}</div>
          <div>累计签到次数</div>
        </div>
      </div>
    </div>

    <div class="list">
      <div class="item" v-for="(item, index) in signList" :key="index">
        <div class="data">{{ item.month }}</div>
        <div class="listn">
          <div
            class="itemn acea-row row-between-wrapper"
            v-for="(itemn, indexn) in item.list"
            :key="indexn"
          >
            <div>
              <div class="name line1">{{ itemn.title }}</div>
              <div>{{ itemn.add_time }}</div>
            </div>
            <div class="num font-color-red">+{{ itemn.number }}</div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getSignMonth } from "@api/user";
import Loading from "@components/Loading";
import {postSignUser} from "../../../api/user";
export default {
  name: "SignRecord",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      page: 1,
      limit: 20,
      signList: [],
      loading: false,
      loadend: false,
      active: false,
      info: [],
    };
  },
  mounted: function() {
    this.getIntegral();
    this.signListTap();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.signListTap();
    });
  },
  methods: {
    getIntegral: function() {
      let that = this;
      postSignUser(that.data).then(
              res => {
                that.info = res.data;
              },
              err => {
                that.$dialog.message(err.msg);
              }
      );
    },
    signListTap: function() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      getSignMonth(that.page, that.limit).then(res => {
        that.loading = false;
        //apply();js将一个数组插入另一个数组;
        that.signList.push.apply(that.signList, res.data);
        that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
        that.page = that.page + 1;
      });
    }
  }
};
</script>
